export default {
  install (app, { store }) {
    const toast = {
      show (options) {
        if (typeof options === 'string') {
          options = { title: options }
        }

        const toastItem = {
          id: Date.now() + Math.random(),
          type: options.type || 'info',
          title: options.title || '',
          message: options.message || '',
          duration: options.duration !== undefined ? options.duration : 5000,
        }

        store.dispatch('toast/add', toastItem)
        return toastItem.id
      },

      success (title, message, duration) {
        return this.show({
          type: 'success',
          title,
          message,
          duration,
        })
      },

      error (title, message, duration) {
        return this.show({
          type: 'error',
          title,
          message,
          duration,
        })
      },

      warning (title, message, duration) {
        return this.show({
          type: 'warning',
          title,
          message,
          duration,
        })
      },

      info (title, message, duration) {
        return this.show({
          type: 'info',
          title,
          message,
          duration,
        })
      },

      remove (id) {
        store.dispatch('toast/remove', id)
      },

      clear () {
        store.dispatch('toast/clear')
      },
    }

    app.config.globalProperties.$toast = toast
    app.provide('toast', toast)
  },
}
